import { render, staticRenderFns } from "./viewNoticeSimpleDetail.vue?vue&type=template&id=76535dc6&scoped=true"
import script from "./viewNoticeSimpleDetail.vue?vue&type=script&lang=js"
export * from "./viewNoticeSimpleDetail.vue?vue&type=script&lang=js"
import style0 from "./viewNoticeSimpleDetail.vue?vue&type=style&index=0&id=76535dc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76535dc6",
  null
  
)

export default component.exports